import * as React from "react";

const SvgComponent = ({ width = "13px", height = "17px", color = "#3783CF" }) => (
  <svg width={width} height={height} viewBox="0 0 13 17" fill="none">
    <path
      d="M3.957 4.26v9.891h.565V7.126l7.348-3.149L3.957.586V4.26Zm1.13 7.126c.455-.04.928-.06 1.413-.06 3.59 0 6.5 1.138 6.5 2.543 0 1.404-2.91 2.543-6.5 2.543S0 15.273 0 13.87c0-.965 1.37-1.803 3.391-2.235v1.556c-.343.155-.565.401-.565.679 0 .467.633.847 1.413.847s1.413-.38 1.413-.847c0-.278-.222-.524-.565-.679v-1.804Zm3.674 2.765c.468 0 .848-.253.848-.565 0-.312-.38-.565-.848-.565-.468 0-.848.253-.848.565 0 .312.38.565.848.565Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;
